import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Areas } from "@/components/Areas";
import { Treatments } from "@/components/Treatments";
import { Gallery } from "@/components/Gallery";
import { WhyChoose } from "@/components/WhyChoose";
import { FAQ } from "@/components/FAQ";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const LandingPage = () => {
  return (
    <div data-testid="landing-page" className="relative bg-[#050505] text-white">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Areas />
        <Treatments />
        <Gallery />
        <WhyChoose />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default LandingPage;
